import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTemplateComponent } from './document-template.component';
import { AddDocumentTemplateComponent } from './add-document-template/add-document-template.component';
import { EditDocumentTemplateComponent } from './edit-document-template/edit-document-template.component';

import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentTemplateSignaturesComponent } from './document-template-signatures/document-template-signatures.component';
import { CloneTemplateDialogComponent } from './clone-template-dialog/clone-template-dialog.component';
import { SmartTemplateBuilderComponent } from './smart-template-builder/smart-template-builder.component';
import { SmartTemplatePartComponent } from './smart-template-part/smart-template-part.component';
import { SmartTemplateAssignmentComponent } from './smart-template-assignment/smart-template-assignment.component';
import { SmartTemplateManagementComponent } from './smart-template-management/smart-template-management.component';
import { TemplateParameterComponent } from './template-parameter/template-parameter.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
	declarations: [
		DocumentTemplateComponent,
		AddDocumentTemplateComponent,
		EditDocumentTemplateComponent,
		DocumentTemplateSignaturesComponent,
		CloneTemplateDialogComponent,
		SmartTemplateBuilderComponent,
		SmartTemplatePartComponent,
		SmartTemplateAssignmentComponent,
		SmartTemplateManagementComponent,
		TemplateParameterComponent,
	],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, DragDropModule],
	exports: [DocumentTemplateComponent],
})
export class DocumentTemplateModule { }
